import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isUserAdmin } from "../utils/userUtils";

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return isUserAdmin(user) ? children : <Navigate to="/" replace />;
};

export default AdminRoute;

